$('body').bind('fx-ready', function(event) {
    $(event.target).find('.targeting-list').each(function() {
        $(this).find('li').addClass('fx-targeting targeting-highlight hoverable');
        $(this).find('li:first').addClass('targeting-list-first');
    });

    var controls;

    var colorbox = $(event.target).find('a.zoom').colorbox({
        'photo': true,
        'rel': 'content',
        'maxHeight': '90%',
        'maxWidth': '90%',
        'title': '',
        'previous': '<a class href="#n">Vorheriges</a>',
        'next': '<a class href="#n">Nächstes</a>',
        'close': 'Schließen (Esc)',
        'onOpen': function() {
            controls = $('a, :input');
            var dialogControls = $('#cboxNext, #cboxPrevious, #cboxClose');
            var otherControls = controls.not(dialogControls);
            otherControls.attr('tabIndex', -1);
        },
        'onClosed': function() {
            controls.removeAttr('tabIndex');
        }
    });
});
